<template>
  <nav class="nav">
    <div class="container">
      <router-link to="/" class="nav__logo d-inline-b">
        <img src="./../assets/images/logo.png" alt="Logo" class="nav__logo-img d-block">
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavbarComponent'
}
</script>

<style scoped lang="scss">
@import "../assets/styles/parts/variables";
@import "../assets/styles/parts/mixins";

.nav {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;

  &__logo {
    margin-top: sm(9.19);
    margin-left: sm(20);
    @include _1024 {
      margin-top: sl(23.79);
      margin-left: 0;
    }
    @include _1920 {
      margin-top: 23.79px;
    }

    &-img {
      width: sm(173);
      height: sm(21);
      @include _1024 {
        width: sl(258);
        height: sl(32.31);
      }
      @include _1920 {
        width: 258px;
        height: 32.31px;
      }
    }
  }
}

</style>
